export const TYPOGRAPHY_SYSTEM = {
  fontFamily: 'Poppins, sans-serif, Pacifico',
  weighs: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  variants: {
    xs: {
      fontSize: '12px',
      lineHeight: '18px',
    },
    sm: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    md: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    lg: {
      fontSize: '18px',
      lineHeight: '28px',
    },
    xl: {
      fontSize: '20px',
      lineHeight: '30px',
    },
  },
}
